export default "__VITE_ASSET__BLomb$R3__"